import React, { useState ,useContext,useEffect, useRef} from 'react';
import { ClubFittingContext } from "../../ClubfittingNew/ClubFittingContext";

const VideoUpload2 = ({step, onfilechange}) => {

    const { updateremotefittingfile,remotefittingimage } = useContext(ClubFittingContext);
    const videoRef = useRef(null);


    const handleFileChange = (e) => {
        const file = e.target.files[0];
        onfilechange(file);
        updateremotefittingfile(step+'.swing2', file);
    };


    useEffect(() => {
        if (videoRef.current) {
            const video = videoRef.current;
            const loadVideoMetadata = () => {
                // Attempt to seek to a frame a little after the start to show as preview
                video.currentTime = 0.5; // Adjust this value as needed
            };
            video.addEventListener('loadedmetadata', loadVideoMetadata);
            return () => {
                video.removeEventListener('loadedmetadata', loadVideoMetadata);
            };
        }
    }, [remotefittingimage, step]);

    const imageURL = remotefittingimage && remotefittingimage[step]?.swing2 instanceof File
        ? URL.createObjectURL(remotefittingimage[step].swing2)
        : null;


    return (
        <div className="card-video">
            <div className="drop_box">
                <input
                    type="file"
                    accept=".mp4,.avi,.mkv"
                    id={`${step}.swing2.fileID`}
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                />
                {imageURL && (
                    <div className="form">
                        <video
                            ref={videoRef}
                            playsInline
                            key={imageURL}
                            style={{ width: '100%',position: "absolute", top: "0",left: "0",height: "98%", borderRadius: "1.5rem", marginTop: "10px",}}
                            controls
                            preload="metadata">
                            <source src={imageURL + ''} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                )}
                <div className='custom-upload-btn'>
                    <button className="btn-upload" onClick={() => document.getElementById(`${step}.swing2.fileID`).click()}>
                        <img src={require('../../../assets/images/photo-camera.png')} alt="upload" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default VideoUpload2;
